import { Link } from "react-router-dom";

export default function CTABanner() {
  return (
    <section className="py-20 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 py-16 md:py-20 px-6 md:px-12 text-center">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 left-10 w-40 h-40 rounded-full bg-white blur-3xl"></div>
            <div className="absolute bottom-10 right-10 w-60 h-60 rounded-full bg-white blur-3xl"></div>
          </div>
          <div className="relative z-10 max-w-2xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4">
              准备好创作你的专属AI美女了吗？
            </h2>
            <p className="text-white/80 mb-10 leading-relaxed">
              现在就开始你的AI美女创作之旅，无需注册，完全免费体验。
              输入你的创意描述，AI将为你打造独一无二的美丽形象。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-primary-600 rounded-full hover:bg-white/95 transition-all duration-300 whitespace-nowrap cursor-pointer font-semibold shadow-lg"
            >
              立即免费体验
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}